// ブラウザの戻る・進む禁止
export const handleBrowzerBack = () => {
  // ダミー履歴を追加
  history.pushState(null, '', null);
  // ダミー履歴の追加を検出するリスナー
  window.addEventListener('popstate', restrictionBrowzerBack);
};

// ブラウザバック禁止
export const restrictionBrowzerBack = () => {
  history.go(1);
};

// ブラウザバック禁止解除
export const releaseBrowzerBack = () => {
  window.removeEventListener('popstate', restrictionBrowzerBack);
};
